import { DeviceConfigMixin } from "./80_DeviceConfig.js";

export abstract class ZWaveNodeMixins extends DeviceConfigMixin {}
